import { useSelector } from "react-redux";
import { IconButton } from "@app/design-system/components";
import { ArrowLeftIcon, PackageIcon } from "@app/design-system/icons";
import { RootState } from "@app/store";
import { t } from "@app/utils/translation";
import { OrderDetailsHeaderProps } from "./OrderDetailsHeader.types";
import styles from "./OrderDetailsHeader.module.css";

/**
 * Order Details' sticky header — back button, page title, order code.
 * Page-specific (like Home's `TrackingHeader`) rather than the generic
 * `shared/layout/TopBar`: the back button's size/color and the trailing
 * order-code + PackageIcon composition are unique to this page's design —
 * if a second page ever needs this exact header, that's the signal to
 * promote it, not before.
 */
export const OrderDetailsHeader = ({ orderCode, isDropoffTracking = false, onBack }: OrderDetailsHeaderProps) => {
  const language = useSelector((state: RootState) => state.setting.language);

  return (
    <header className={styles.header}>
      <IconButton
        icon={<ArrowLeftIcon size={20} />}
        aria-label={t("GoBack", language)}
        onClick={onBack}
        className={styles.backButton}
      />
      <h1 className={styles.title}>{t("OrderDetails", language)}</h1>
      {orderCode && !isDropoffTracking ? (
        <span className={styles.orderCode}>
          <PackageIcon size={20}  />
          <span className={styles.orderCodeText}>{orderCode}</span>
        </span>
      ) : null}
    </header>
  );
};
